<form [formGroup]="form" (ngSubmit)="enviar()" *ngIf="!carregando">
  <div class="form-group mb-4 bg-white">
    <label>Faça o upload do arquivo</label>
    <div class="d-block">
      <button class="btn btn-dashed"
              [ngClass]="{'btn-dashed-danger':
                !validarFormulario && fc?.extensaoArquivo?.invalid && nomeArquivo ||
                fc?.base64?.errors?.fileSizeExceeded && nomeArquivo ||
                fc?.extensaoArquivo?.invalid && nomeArquivo ||
                fc.base64.invalid && !validarFormulario}"
              type="button" (click)="fileInput.click()">
        <span>Apenas ".png", ".jpg", ".jpeg" ou ".pdf". <img class="ms-2" src="assets/imgs/icones/upload.svg" alt=""></span>
      </button>
      <input hidden (change)="uploadArquivo($event)" #fileInput type="file" id="file"
             accept=".png,.jpg,.jpeg,.pdf"
             [ngClass]="{'is-invalid':
               !validarFormulario && fc?.extensaoArquivo?.invalid && nomeArquivo ||
                fc?.base64?.errors?.fileSizeExceeded && nomeArquivo ||
                fc?.extensaoArquivo?.invalid && nomeArquivo ||
               fc.base64.invalid && !validarFormulario}">
      <div *ngIf="nomeArquivo && !fc?.extensaoArquivo?.invalid && !fc?.base64?.errors?.fileSizeExceeded" class="mt-1">
          <span class="txt-nome-arquivo-upload-v2 color-primario">
              {{nomeArquivo}}
          </span>
        <img src="assets/imgs/icones/check-verde.svg" alt="">
      </div>
      <div *ngIf="progressoUpload !== null" class="progress mt-2" style="height: 6px;">
        <div class="progress-bar" role="progressbar"
             [style.width.%]="progressoUpload"
             [attr.aria-valuenow]="progressoUpload" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div *ngIf="progressoUpload !== null" class="mt-1">
        <small class="color-primario">Enviando… {{progressoUpload}}%</small>
      </div>
      <div class="invalid-feedback">
        <span *ngIf="fc?.extensaoArquivo?.invalid && nomeArquivo">O documento enviado não está em um dos formatos aceitos (PDF, JPG, JPEG, PNG).</span>
        <span *ngIf="fc?.base64?.errors?.fileSizeExceeded && nomeArquivo">O documento excede o tamanho máximo permitido de 200 MB.</span>
        <span *ngIf="!validarFormulario && fc?.base64?.errors?.required && !nomeArquivo">Campo obrigatório</span>
      </div>
    </div>
  </div>
  <div class="mb-4 container-fluid">
    <div class="row">
      <div class="col p-0">
        <app-input-select class="w-100" [label]="'Qual documento você está enviando?'" [id]="'nomeExterno'" [tipoNumber]="false" [placeholder]="''"
                          [invalid]="form.controls.nomeExterno.invalid &&
                                     form.controls.tipoDocumento.invalid && !validarFormulario"
                          [tipoSelectNumber]="false" [required]="false"
                          (funcaoExterna)="tipoDocumentoSelecionado($event)"
                          formControlName="nomeExterno" [list]="tipoDocumento"></app-input-select>
      </div>
      <div class="col-4 d-flex justify-content-end"
           [ngClass]="!validarFormulario && fc?.base64?.errors?.required && !nomeArquivo ||
            fc?.base64?.errors?.fileSizeExceeded && nomeArquivo
            ?  'align-items-center' : 'align-items-end'"
      >
        <button type="submit" class="btn btn-primary float-end btn-sm w-100 h-auto">
          Enviar
          <img class="ms-2" src="assets/imgs/icones/upload-white.svg" alt="">
        </button>
      </div>
    </div>
  </div>
</form>
